import { render, staticRenderFns } from "./myMoreText.vue?vue&type=template&id=338ca2e4&scoped=true&"
import script from "./myMoreText.vue?vue&type=script&lang=js&"
export * from "./myMoreText.vue?vue&type=script&lang=js&"
import style0 from "./myMoreText.vue?vue&type=style&index=0&id=338ca2e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338ca2e4",
  null
  
)

export default component.exports